import {Button} from '@chekinapp/ui';
import {cn} from '@chekin/guestapp-ui-kit';
import {KIOSKO_BUTTON_CLASSES} from 'utils/kioskoClasses';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useKioskoStore, useDispenserControls, useGuestCardStore} from 'context/kiosko';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';

type Props = {
  onPrintCard: () => void;
};

function PrintKeyCardButton({onPrintCard}: Props) {
  const {t} = useTranslation();
  const pending = useKioskoStore(state => state.cards.pending);
  const isKiosko = useKioskoStore(state => state.connection.isConnected);
  const guestCardData = useGuestCardStore(state => state.guestCardData);
  const {printCard} = useDispenserControls();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const handleOnClick = () => {
    if (pending > 0 && guestCardData) {
      printCard(guestCardData);
      onPrintCard();
    } else {
      navigate(getFullPath(PATHS.remoteKeys));
    }
  };

  if (
    !isKiosko ||
    !guestCardData ||
    !guestCardData.guest_name ||
    !guestCardData.room_number
  ) {
    return null;
  }

  return (
    <Button
      variant="link"
      onClick={handleOnClick}
      className={cn('kiosko:mx-auto kiosko:mb-12', KIOSKO_BUTTON_CLASSES)}
    >
      {pending > 0 ? t('print_keycard') : t('go_to_keycards')}
    </Button>
  );
}

export {PrintKeyCardButton};
